import React from 'react'
import styled from '@emotion/styled'
import {css} from '@emotion/core'

export type PropsType = {
  /** Country code of the flag that should be displayed */
  countryCode?: string
  /** The size of the flag */
  size?: number
  /** Pass through classname to allow styles overrides */
  className?: string
}

const StyledFlag = styled('img')<{size: number}>(
  ({size}) => css`
    width: ${size}px;
  `
)

const Flag = ({countryCode = 'gb', size = 20, className}: PropsType) => (
  <StyledFlag
    className={className}
    alt={countryCode}
    src={require(`../../../foundation/flags/${countryCode}.svg`)}
    size={size}
  />
)

export default Flag
